fragment ActivityTranscriptAndSummaryFragment on Activity {
    id
    transcription
    transcriptionStatus
    summary {
        id
        summary
        status
    }
    logNote {
        id
        audioLog {
            href
            fileId
        }
    }
    externalMeeting {
        id
        recordingStatus
        recordingUrl
    }
    generatingSummary
    generatingRecording
    shouldDisplayAudio
    summaryStates {
        recordingEmptyState
        transcriptionEmptyState
        summaryEmptyState
        summaryNextAction
        isNotetakerDisabled
    }
}
